import React from "react";
import { motion } from "framer-motion";
import aUP1Line from "../../../assets/aUP1Vector.svg";

function AboutUsTitle(): React.ReactNode {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        staggerChildren: 0.3,
        delayChildren: 0.2,
      },
    },
  };

  const titleVariants = {
    hidden: {
      opacity: 0,
      y: 100,
      scale: 0.8,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 1.2,
        type: "spring",
        bounce: 0.4,
      },
    },
  };

  const lineVariants = {
    hidden: {
      opacity: 0,
      scale: 0,
      rotate: -180,
    },
    visible: {
      opacity: 1,
      scale: 1,
      rotate: 0,
      transition: {
        duration: 1,
        type: "spring",
        bounce: 0.6,
      },
    },
  };

  const subtitleVariants = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        type: "spring",
        bounce: 0.3,
      },
    },
  };

  return (
    <div className="w-full h-screen bg-black flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 overflow-hidden">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="w-full max-w-4xl flex flex-col items-center justify-center text-center"
      >
        <motion.h1
          className="text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold font-montserrat leading-tight mb-6 lg:mb-8"
          initial={{ opacity: 0, y: 100, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.5, ease: "backOut" }}
        >
          <motion.span
            initial={{ opacity: 0, x: -100, rotateY: -90 }}
            animate={{ opacity: 1, x: 0, rotateY: 0 }}
            transition={{ duration: 0.8, delay: 0.5, ease: "backOut" }}
            className="text-white inline-block"
          >
            CONOCE A GRUPO{` `}
          </motion.span>
          <br />
          <motion.span
            initial={{ opacity: 0, y: 100, scale: 0.3, rotateX: -90 }}
            animate={{ opacity: 1, y: 0, scale: 1, rotateX: 0 }}
            transition={{
              duration: 1.2,
              delay: 0.9,
              ease: "backOut",
              type: "spring",
              bounce: 0.4,
            }}
            className="text-white inline-block"
          >
            PEÑA DEFILLÓ{` `}
          </motion.span>
        </motion.h1>

        <motion.img
          initial={{ opacity: 0, scale: 0, rotate: -180 }}
          animate={{ opacity: 1, scale: 1, rotate: 0 }}
          transition={{ duration: 1, type: "spring", bounce: 0.6 }}
          src={aUP1Line}
          className="w-full h-auto mb-4 cursor-pointer"
          alt="Decorative line"
        />

        <motion.p
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, type: "spring", bounce: 0.3 }}
          whileHover={{
            scale: 1.05,
            transition: { duration: 0.2 },
          }}
          className="text-white text-lg sm:text-lg lg:text-xl xl:text-2xl font-medium font-montserrat cursor-default"
        >
          Nos alegra que estés aquí
        </motion.p>
      </motion.div>

      {/* Animated background particles */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.1 }}
        transition={{ duration: 2, delay: 1.5 }}
        className="absolute inset-0 pointer-events-none"
      >
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            initial={{
              opacity: 0,
              x: Math.random() * window.innerWidth,
              y: Math.random() * window.innerHeight,
              scale: 0,
            }}
            animate={{
              opacity: [0, 0.3, 0],
              scale: [0, 1, 0],
              x: Math.random() * window.innerWidth,
              y: Math.random() * window.innerHeight,
            }}
            transition={{
              duration: Math.random() * 3 + 2,
              delay: Math.random() * 2 + 1,
              repeat: Infinity,
              repeatDelay: Math.random() * 3 + 1,
            }}
            className="absolute w-1 h-1 bg-white rounded-full"
          />
        ))}
      </motion.div>
    </div>
  );
}

export default AboutUsTitle;
